import { render, staticRenderFns } from "./SmartAlerts.vue?vue&type=template&id=44a82b63&scoped=true"
import script from "./SmartAlerts.vue?vue&type=script&lang=js"
export * from "./SmartAlerts.vue?vue&type=script&lang=js"
import style0 from "./SmartAlerts.vue?vue&type=style&index=0&id=44a82b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a82b63",
  null
  
)

export default component.exports